import React from 'react';
import { TextField } from '@mui/material';
import { getCommonTextFieldStyles, sanitizeNumberInput } from '../../_utils/fieldInputHelpers';

export interface BaseNumberInputProps {
  value: string | number;
  onChange: (value: string) => void;
  label?: string;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  error?: string;
  helperText?: string;
  size?: 'small' | 'medium';
  fullWidth?: boolean;
  min?: number;
  max?: number;
}

const BaseNumberInput: React.FC<BaseNumberInputProps> = ({
  value,
  onChange,
  label,
  placeholder = 'Enter number',
  required = false,
  disabled = false,
  error,
  helperText,
  size = 'small',
  fullWidth = true,
  min = 0,
  max,
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;

    // Basic sanitization: only allow digits and empty string
    // Remove internal validation that prevents input - let form validation handle errors
    if (newValue === '' || /^\d+$/.test(newValue)) {
      onChange(newValue);
    }
  };

  const stringValue = typeof value === 'number' ? value.toString() : value || '';

  return (
    <TextField
      type='number'
      label={label}
      value={stringValue}
      onChange={handleChange}
      placeholder={placeholder}
      required={required}
      disabled={disabled}
      error={!!error}
      helperText={error || helperText}
      size={size}
      fullWidth={fullWidth}
      variant='outlined'
      inputProps={{
        step: 1,
        min: min,
        max: max,
        pattern: '[0-9]*',
      }}
      sx={getCommonTextFieldStyles()}
    />
  );
};

export default BaseNumberInput;
